import { datadogRum } from '@datadog/browser-rum'
import { ReactElement, useEffect } from 'react'
import { Env } from 'constants/common'

type DataDogProps = {
  children: ReactElement
}

const Datadog: React.FC<DataDogProps> = ({ children }) => {
  useEffect(() => {
    const applicationId = process.env.NEXT_PUBLIC_DATADOG_APP_ID
    const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN
    const initializeDatadog = !!applicationId && !!clientToken

    if (initializeDatadog) {
      // Origin of the backend API (axios baseURL in utils/callApi.ts). Allowing it here
      // makes the RUM SDK inject Datadog tracing headers into API calls so the browser
      // trace continues into the backend APM trace — one connected frontend→backend trace.
      const apiUrl = process.env.NEXT_PUBLIC_SERVER_URL

      datadogRum.init({
        applicationId,
        clientToken,
        site: 'datadoghq.com',
        service: 'thriveworks-web-service',
        env: process.env.VERCEL_GIT_COMMIT_REF ?? Env.DEV,
        version: process.env.VERCEL_GIT_COMMIT_SHA || '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        silentMultipleInit: true,
        allowedTracingUrls: apiUrl ? [apiUrl] : [],
        // Sample of browser-originated requests force-kept for frontend→backend trace
        // correlation. Kept low: error traces are retained by the backend regardless, so
        // this mostly governs how much successful public traffic we pay to ingest.
        traceSampleRate: 20,
      })
    }
  }, [])

  return children
}

export default Datadog
